import React from "react";

const Statuses = ({ status = "default", text }) => {
  return <div className={`label-status label-status--${status}`}>{text}</div>;
};

export default Statuses;
